<div class="results">
	<ansyn-results-table></ansyn-results-table>
</div>
